export const black = '#111212';
export const grey = '#C5C6C6';
export const blue = '#4B74CB';
export const red = '#DA2C25';
export const lightGray = '#F3F4F4';
export const hoverBlue = '#00D2EB';
export const background = '#FBFCFD';
export const lightGrayThird = '#E8E8E8';
export const lightBlue = '#F0F9FA';
export const mainGray = '#626262';
